<template>
  <div class="px-4 py-2">
    <v-card class="elevation-20">
      <v-card-title style="background-color: #ffa726;" primary-title>
        <div style="color: black; font-weight:bold; font-size: 20px;">
          {{cardName}}
        </div>
        <div style="margin-left:auto; margin-right:0;">
          <v-icon
            large
            left
            @click="cardshow = !cardshow"
          >
            {{cardshow ? 'mdi-minus' : 'mdi-crop-square'}}
          </v-icon>
        </div>
      </v-card-title>
      <v-layout row wrap justify-center py-4 v-show="cardshow">
        <v-flex xs5 md5 lg3 xl2 px-3>
          <div class="text-input">ระบุจำนวนปีที่ต้องการให้แสดง</div>
          <v-select
            v-model="selYear"
            ref="selYear"
            :items="selYearArray"
            item-text="text"
            item-value="value"
            value="{ selYear }"
            box
            placeholder="">
          </v-select>
        </v-flex>
        <v-flex xs1 px-3 pt-3>
          <v-btn color="info" :disabled="!(selYear)" v-on:click="searchData"><v-icon class="mr-2 mdi-24px">mdi-magnify</v-icon >ค้นหา</v-btn>
        </v-flex>
      </v-layout>
    </v-card>
    <br>
    <v-layout v-if="showTable">
      <v-flex xs12 pt-1 style="text-align: center"><label>{{ titleMenuShow }} ในรอบ {{ yearshow }} ปี</label></v-flex>
    </v-layout>
    <v-layout v-if="showTable">
      <v-flex xs7 px-1 pt-4 v-if="([$route.params.id] == 5)">
        <v-data-table
          :headers="headers"
          :items="listData"
          :pagination.sync="pagsort"
          :rows-per-page-items="rowsPerPageItems"
          hide-actions
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.year }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.birth) }}</td>
            <td class="text-xs-right">{{ formatRatio(props.item.result1) }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.death) }}</td>
            <td class="text-xs-right">{{ formatRatio(props.item.result2) }}</td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs7 px-1 pt-4 v-else-if="([$route.params.id] == 6)">
        <v-data-table
          :headers="headers"
          :items="listData"
          :pagination.sync="pagsort"
          :rows-per-page-items="rowsPerPageItems"
          hide-actions
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.year }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.birth) }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.death) }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.result1) }}</td>
            <td class="text-xs-right">{{ formatRatio(props.item.result2) }}</td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs5 px-1 pt-4 v-else>
        <v-data-table
          :headers="headers"
          :items="listData"
          :pagination.sync="pagsort"
          :rows-per-page-items="rowsPerPageItems"
          hide-actions
          class="elevation-5 tableCus tableCusColor"
        >
          <template slot="items" slot-scope="props">
            <td class="text-xs-center">{{ props.item.year }}</td>
            <td class="text-xs-right">{{ formatNumber(props.item.result) }}</td>
            <td class="text-xs-right">{{ formatRatio(props.item.growthRate) }}</td>
          </template>
        </v-data-table>
      </v-flex>
      <v-flex xs1 px-1 pt-1></v-flex>
      <v-flex xs6 px-1 pt-1>
        <ApexCharts type=line height="500" :options="chartOptions" :series="series" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { sync } from 'vuex-pathify'
import apiRpStat from '../modules/api/apiRpStat.js'
import dateFunction from '../modules/models/dateFunction'
import ApexCharts from 'vue-apexcharts'
export default {
  computed: {
    ...sync('*')
  },
  name: 'ReportTenYear',
  props: [
    'id'
  ],
  data () {
    return {
      flagID: null,
      selYear: null,
      selYearArray: [
        { text: '3 ปี', value: '3' },
        { text: '4 ปี', value: '4' },
        { text: '5 ปี', value: '5' },
        { text: '6 ปี', value: '6' },
        { text: '7 ปี', value: '7' },
        { text: '8 ปี', value: '8' },
        { text: '9 ปี', value: '9' },
        { text: '10 ปี', value: '10' }
      ],
      showTable: false,
      rowsPerPageItems: [10, 20, 30, 40, {'text': '$vuetify.dataIterator.rowsPerPageAll', 'value': -1}],
      pagsort: {
        sortBy: 'year',
        descending: false
      },
      headers: [],
      listData: [],
      titleMenuShow: null,
      titleMenu: [
        'แสดงข้อมูลอัตราการเพิ่มลดของประชากร',
        'แสดงข้อมูลอัตราการเพิ่มลดของบุคคลไม่ได้สัญชาติไทย',
        'แสดงข้อมูลอัตราการเกิด',
        'แสดงข้อมูลอัตราการตาย',
        'แสดงข้อมูลอัตราการเกิดเปรียบเทียบกับอัตราการตาย',
        'แสดงข้อมูลอัตราการเกิดมากกว่าอัตราการตาย',
        'แสดงข้อมูลอัตราการเพิ่มลดของจำนวนบ้าน',
        'แสดงข้อมูลการออกบัตร'
      ],
      series: [],
      chartOptions: [],
      heightLine: 300,
      tickLine: 2,
      yearshow: '',
      cardshow: true,
      cardName: '',
      listName: [
        '',
        '1. แสดงข้อมูลอัตราการเพิ่มลดของประชากร',
        '2. แสดงข้อมูลอัตราการเพิ่มลดของบุคคลไม่ได้สัญชาติไทย',
        '3. แสดงข้อมูลอัตราการเกิด',
        '4. แสดงข้อมูลอัตราการตาย',
        '5. แสดงข้อมูลอัตราการเกิดเปรียบเทียบกับอัตราการตายในรอบ 10 ปี',
        '6. แสดงข้อมูลอัตราการเกิดมากกว่าอัตราการตายในรอบ 10 ปี',
        '7. แสดงข้อมูลอัตราการเพิ่มลดของจำนวนบ้าน',
        '8. แสดงข้อมูลการออกบัตร'
      ]

    }
  },
  components: {
    ApexCharts
  },
  created () {
    // console.log(this.$route.params.id)
    this.flagID = this.$route.params.id
    this.selYear = '3'
    this.titleMenuShow = this.titleMenu[this.$route.params.id - 1]
    this.cardName = this.listName[this.$route.params.id]
    this.series = []
    this.chartOptions = []
  },
  mounted () {
    this.runChart()
  },
  watch: {
    '$route.params.id': {
      handler: function (id) {
        if (id !== this.flagID) {
          this.showTable = false
          this.selYear = '3'
          this.titleMenuShow = null
          this.listData = []
          // this.listData2 = []
          // this.listData3 = []
        }
        this.flagID = id
        this.titleMenuShow = this.titleMenu[id - 1]
        this.cardName = this.listName[id]
      }
    }
  },
  methods: {
    searchData: async function () {
      this.listData = []
      this.series = []
      this.chartOptions = []
      this.yearshow = this.selYear
      if (parseInt(this.selYear) === 3) {
        this.heightLine = '300'
      } else if (parseInt(this.selYear) >= 8) {
        this.heightLine = '500'
      } else {
        this.heightLine = '400'
      }
      // console.log(this.heightLine)
      this.runChart()
      if (this.flagID === '1') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนประชากร (คน)', value: 'result', align: 'right', sortable: false },
          { text: 'อัตราการเพิ่มลด', value: 'growthRate', align: 'right', sortable: false }
        ]
      } else if (this.flagID === '2') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวน (คน)', value: 'result', align: 'right', sortable: false },
          { text: 'อัตราการเพิ่มลด', value: 'growthRate', align: 'right', sortable: false }
        ]
      } else if (this.flagID === '3') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนคนเกิด (คน)', value: 'result', align: 'right', sortable: false },
          { text: 'อัตราการเพิ่มลด', value: 'growthRate', align: 'right', sortable: false }
        ]
      } else if (this.flagID === '4') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนคนตาย (คน)', value: 'result', align: 'right', sortable: false },
          { text: 'อัตราการเพิ่มลด', value: 'growthRate', align: 'right', sortable: false }
        ]
      } else if (this.flagID === '5') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนคนเกิด (คน)', value: 'birth', align: 'center', sortable: false },
          { text: 'อัตราการเพิ่มลด (เกิด)', value: 'result1', align: 'center', sortable: false },
          { text: 'จำนวนคนตาย (คน) ', value: 'death', align: 'center', sortable: false },
          { text: 'อัตราการเพิ่มลด (ตาย) ', value: 'result2', align: 'center', sortable: false }
        ]
      } else if (this.flagID === '6') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนคนเกิด (คน)', value: 'birth', align: 'center', sortable: false },
          { text: 'จำนวนคนตาย (คน)', value: 'death', align: 'center', sortable: false },
          { text: 'จำนวนคนเกิดมากกว่าคนตาย', value: 'result1', align: 'center', sortable: false },
          { text: 'อัตราการเกิดมากกว่าอัตราการตาย', value: 'result2', align: 'center', sortable: false }
        ]
      } else if (this.flagID === '7') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนบ้าน', value: 'result', align: 'right', sortable: false },
          { text: 'อัตราการเพิ่มลด', value: 'growthRate', align: 'right', sortable: false }
        ]
      } else if (this.flagID === '8') {
        this.headers = [
          { text: 'ปี พ.ศ.', value: 'year', align: 'center', sortable: false },
          { text: 'จำนวนการออกบัตร', value: 'result', align: 'right', sortable: false },
          { text: 'อัตราการเพิ่มลด', value: 'growthRate', align: 'right', sortable: false }
        ]
      }
      this.showTable = true
      try {
        await apiRpStat.rpTenYear(this.flagID, this.selYear).then((resData) => {
          // console.log('resData',resData, 'status', resData.status)
          if (resData.status === 404) {
            this.listData = []
          } else {
            this.listData = []
            this.listData = resData
            this.runChart()
          }
        })
      } catch (error) {
        this.alertBox.showAlert('ไม่สามารถค้นหาข้อมูลได้', 'error', 'เกิดข้อผิดพลาด')
      }
    },
    formatNumber (val) {
      return dateFunction.formatNumber(val)
    },
    formatRatio (val) {
      return dateFunction.formatRatio(val)
    },
    runChart () {
      this.tickLine = parseInt(this.selYear)
      // console.log(this.tickLine, this.selYear)
      let dataYear = []
      let dataResult = []
      let dataResult2 = []
      let dataRatio = []
      let dataRatio2 = []
      let colorData = [ '#77B6EA' ]
      let chartText = ''
      if (this.flagID === '5') {
        colorData = [ '#77B6EA', '#FF6D00' ]
        this.listData.forEach((val, idx) => {
          dataYear.push(val.year)
          dataResult.push(val.birth)
          dataResult2.push(val.death)
          dataRatio.push(this.formatRatio(val.result1))
          dataRatio2.push(this.formatRatio(val.result2))
        })
      } else if (this.flagID === '6') {
        chartText = 'จำนวนคนเกิดมากกว่าคนตาย : '
        this.listData.forEach((val, idx) => {
          dataYear.push(val.year)
          dataResult.push(val.result1)
          dataRatio.push(this.formatRatio(val.result2))
        })
      } else {
        if (this.flagID === '1') {
          chartText = 'จำนวนประชากร : '
        } else if (this.flagID === '2') {
          chartText = 'จำนวน : '
        } else if (this.flagID === '3') {
          chartText = 'จำนวนคนเกิด : '
        } else if (this.flagID === '4') {
          chartText = 'จำนวนคนตาย : '
        } else if (this.flagID === '7') {
          chartText = 'จำนวนบ้าน : '
        } else if (this.flagID === '8') {
          chartText = 'จำนวนการออกบัตร : '
        }
        this.listData.forEach((val, idx) => {
          dataYear.push(val.year)
          dataResult.push(val.result)
          dataRatio.push(this.formatRatio(val.growthRate))
        })
      }
      // console.log(dataResult)
      if (this.flagID === '5') {
        this.series = [
          {
            name: 'จำนวนคนเกิด',
            data: dataResult
          },
          {
            name: 'จำนวนคนตาย',
            data: dataResult2
          }
        ]
      } else {
        this.series = [
          {
            name: '',
            // data: [28, 29, 33, 36, 32, 32, 33]
            data: dataResult
          }
        ]
      }
      this.chartOptions = {
        chart: {
          shadow: {
            enabled: true,
            color: '#000',
            top: 18,
            left: 7,
            blur: 10,
            opacity: 1
          },
          toolbar: {
            show: false
          }
        },
        colors: colorData,
        dataLabels: {
          enabled: true,
          formatter: function (val, opts) {
            var intPartFormat = val.toString()
            if ((val === '') || (val.length < 3)) {
              return intPartFormat
            } else {
              var intPart = parseInt(val).toFixed(0)
              intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
            }
            return intPartFormat
          },
          textAnchor: 'middle',
          style: {
            colors: ['#3E2723']
          }
        },
        tooltip: {
          enabled: true,
          x: {
            show: false
          },
          y: {
            formatter: function (val, opts) {
              // console.log('val', val, 'opts', opts)
              var intPartFormat = val.toString()
              if ((val === '') || (val.length < 3)) {
                return intPartFormat
              } else {
                var intPart = parseInt(val).toFixed(0)
                intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
              }
              if (opts.seriesIndex === 1) {
                return intPartFormat + ' , อัตรา : ' + dataRatio2[opts.dataPointIndex]
              } else {
                return chartText + intPartFormat + ' , อัตรา : ' + dataRatio[opts.dataPointIndex]
              }
            }
          }
        },
        stroke: {
          curve: 'smooth'
        },
        title: {
          // text: 'Average High & Low Temperature',
          // align: 'left'
        },
        grid: {
          show: true,
          borderColor: '#e7e7e7',
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        markers: {
          size: 6
        },
        xaxis: {
          // categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'],
          categories: dataYear,
          title: {
            // text: 'Month'
          },
          tickPlacement: 'between'
        },
        yaxis: {
          tickAmount: this.tickLine,
          // min: function(min) {
          //   min = min - ((min*1)/100)
          //   // console.log('min' , min)
          //   return min
          // },
          // max: function(max) {
          //   max = max + ((max*10)/100)
          //   console.log('max' , max)
          //   return max
          // },
          labels: {
            formatter: function (val) {
              var intPartFormat = val.toString()
              if ((val === '') || (val.length < 3)) {
                return intPartFormat
              } else {
                var intPart = parseInt(val).toFixed(0)
                intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
              }
              // console.log(intPartFormat)
              return intPartFormat
            }
          },
          title: {
            // text: 'Temperature'
          }
          // min: 5,
          // max: 40
        },
        legend: {
          position: 'top',
          horizontalAlign: 'right',
          floating: true,
          offsetY: -25,
          offsetX: -5
        }
      }
    }
  }
}
</script>
